import { LOGIN_SUCCESS } from 'core/services/login/action-types';

TokenService.$inject = ['$ngRedux', '$window', 'localStorageService'];

/**
 * TokenService es un servicio requerido por ui-auth, para poder
 * determinar el token de la sesión actual.
 */
export default function TokenService($ngRedux, $window, localStorageService) {
  return {
    getToken() {
      let { accessToken } = $ngRedux.getState().login;
      let token;

      if (accessToken) {
        token = accessToken.token;
      }
      return token;
    },

    getRefreshToken() {
      let { accessToken } = $ngRedux.getState().login;
      let token;

      if (accessToken) {
        token = accessToken.refreshToken;
      }
      return token;
    },

    /**
     * Metodo invocado cuando el par access_token/refresh_token se actualizó.
     * @param {object} token
     */
    setToken(token) {
      if (token.refreshToken && token.token) {
        $ngRedux.dispatch({ type: LOGIN_SUCCESS, payload: token });
      } else {
        this.logout();
      }
    },

    logout() {
      let caja = localStorageService.get('caja');
      localStorage.clear();
      localStorageService.set('caja', caja);
      $window.location.reload();
    }

  };


}


// WEBPACK FOOTER //
// ./src/core/services/token-service.js